export const customMessages = {
  date: 'תאריך',
  time: 'שעה',
  event: 'אירוע',
  allDay: 'כל היום',
  week: 'שבוע',
  work_week: 'שבוע עבודה',
  day: 'יום', // Customize "day" view name
  month: 'חודש', // Customize "month" view name
  previous: 'הקודם',
  next: 'הבא',
  today: 'היום',
  agenda: 'Select Your Agenda', // Customize "agenda" view name
  noEventsInRange: 'אין אירועים בטווח זה',
};
